<app-header-app xLink="/login"></app-header-app>
<div class="header-divider"></div>
<app-form-template title="{{ 'VERIFY_EMAIL.TITLE' | translate }}">
  <div class="description">
    {{ "VERIFY_EMAIL.DESCRIPTION" | translate }}
  </div>

  <payee-horizontal-line></payee-horizontal-line>

  <div class="flex vcenter hcenter">
    <span color="grey-dark">{{ "VERIFY_EMAIL.EMAIL_NOT_RECIEVED" | translate }}</span>
    &nbsp;
    <a
      class="resend-link"
      href="#"
      role="button"
      [attr.color]="!resendPressed ? 'blue-payee' : 'grey-medium'"
      (click)="resendVerifyEmail(); $event.preventDefault()"
      (keydown.enter)="resendVerifyEmail(); $event.preventDefault()"
    >
      {{ "VERIFY_EMAIL.RESEND" | translate }}
    </a>
    @if (loading()) {
      &nbsp;
      <mat-progress-spinner
        color="primary"
        mode="indeterminate"
        diameter="16"
      ></mat-progress-spinner>
    }
  </div>
</app-form-template>
